import React, { useEffect, useState } from 'react';
import { BannerContainer, BannerImage } from './styled';

export default function SingleBanner(props) {
  let { data, index, forceMobileViewAssetsDownload, normalHeight ,lactoMama} = props;

  const [showMobileView, setShowMobileView] = useState(true);
  const getDesktopImage = (data) => {
    return data?.desktopImage || data?.mobileWebImage || data?.image;
  };
  const getMobileImage = (data) => {
    return data?.mobileWebImage || data?.desktopImage || data?.image;
  };

  useEffect(() => {
    const updateView = () => {
      if (!forceMobileViewAssetsDownload) {
        if (window.innerWidth > 720) {
          setShowMobileView(false);
        } else {
          setShowMobileView(true);
        }
      } else {
        setShowMobileView(true);
      }
    };
    // Run once on mount
    updateView();

    // Add a resize listener
    window.addEventListener('resize', updateView);

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', updateView);
  }, []); // No window dependency here, safe for SSR
  return (
    <BannerContainer firstImage={index === 0} lactoMama={lactoMama}>
      {showMobileView ? (
        <BannerImage
          srcSet={`${getMobileImage(data)}?tr=w-500,q-80 2w, ${getMobileImage(
            data,
          )}?tr=w-1000,q-80 608w`}
          sizes="(max-width: 720px) 2px,608px"
          src={getMobileImage(data) + '?tr=w-360,q-80'}
          alt="Single Banner"
          loading={index < 2 ? 'eager' : 'lazy'}
          firstImage={index === 0}
          lactoMama={lactoMama}
        />
      ) : (
        <BannerImage
          srcSet={`${getDesktopImage(data)}?tr=w-500,q-80 2w, ${getDesktopImage(
            data,
          )}?tr=w-1000,q-80 608w`}
          sizes="(max-width: 720px) 2px,608px"
          src={getDesktopImage(data) + '?tr=w-360,q-80'}
          alt="Single Banner"
          loading={index < 2 ? 'eager' : 'lazy'}
          firstImage={index === 0}
          lactoMama={lactoMama}
        />
      )}
    </BannerContainer>
  );
}
